import * as tslib_1 from "tslib";
var InviteUserToMeetingController = /** @class */ (function () {
    /*@ngInject*/
    function InviteUserToMeetingController($rootScope, $timeout, $filter, moment, modalService, browserService, dateTimeUtilityService, jobMatchService, jobService, userService, userRoleService, employeeService, meetingService, alertsAndNotificationsService, sharedAjsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.modalService = modalService;
        this.browserService = browserService;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.userService = userService;
        this.userRoleService = userRoleService;
        this.employeeService = employeeService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.sharedAjsService = sharedAjsService;
    }
    InviteUserToMeetingController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.mode = "edit";
        this.jobId = null;
        this.scheduleData = {
            meetingScheduleId: this.scheduleId,
            isCompany: true,
            jobMatchId: '',
            company: '',
            feedbackType: 'SINGLE',
            note: '',
            externalNote: '',
            startDateTime: '',
            endDateTime: '',
            timeZoneName: '',
            meetingMode: 'VIDEO',
            link: '',
            users: [],
            jobLocation: this.jobLocation
        };
        this.selectedUserObject = undefined;
        this.selectedUserObjectsArray = [];
        this.externalNotesAction = {};
        this.userSearchPlaceholder = 'Type first name or last name or email to search.';
        this.itemDisplayLabel = '';
        this.usersListLabel = '';
        this.userTypeLabel = '';
        this.scheduleLabel = 'Schedule';
        this.noEditableMeetingsLabel = '';
        this.companyName = '';
        this.companyId = '';
        this.clientName = '';
        this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
        this.sharedReqCorporationName = '';
        this.sharedReqBUName = '';
        this.sharedReqVendorName = '';
        this.chosenMeeting = '';
        this.clientorbulist = [];
        this.meetingsList = [];
        this.startDate = '';
        this.startTime = '';
        this.endDate = '';
        this.endTime = '';
        this.browserTimeZone = null;
        this.addUserTabIndex = 0;
        this.buList = [];
        this.meetingModes = [];
        //flags
        this.viewMode = false;
        this.savingFlag = false;
        this.editModeFlag = false;
        this.showFormFlag = false;
        this.loadingFlag = false;
        this.isCorporateFlag = false;
        this.editableMeetingsExistFlag = false;
        this.userSearchFlag = true;
        this.showAddUserOptionFlag = true;
        this.canAddUserAtCompanyLevel = false;
        this.canAddUserAtClientOrBULevel = false;
        this.isUserVendor = false;
        this.isSharedRequisitionAccessedByVendor = false;
        this.showTagsInput = true;
        this.isFirstModifyScheduleTimeCall = false;
        this.invalidStartDateTime = false;
        this.invalidEndDateTime = false;
        this.invalidStartEndTime = false;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporateFlag = (this.$rootScope.userDetails.company.companyType == 'Corporation');
        this.browserTimeZone = this.dateTimeUtilityService.guessBrowserTimeZoneName();
        this.editModeFlag = true;
        this.scheduleLabel = 'Modify';
        this.getScheduledItems();
        if (this.isCorporateFlag) {
            var searchObject = {
                'searchText': '',
                'companyId': this.companyId
            };
            this.scheduleData.isCompany = this.jobMatchObject.isCorporateLevelRequisition;
            if (!this.scheduleData.isCompany) {
                this.buList = [];
                this.buList.push({ id: this.jobMatchObject.jobMatchClientId, name: this.jobMatchObject.jobMatchClientName });
            }
        }
        this.scheduleData.jobMatchId = this.jobMatchId;
        this.scheduleData.company = this.companyId;
        this.jobId = this.jobMatchObject.jobMatchJobId;
        this.companyName = this.$rootScope.userDetails.company.companyName;
        this.clientName = this.jobMatchObject.jobMatchClientName;
        this.clientId = this.jobMatchObject.jobMatchClientId;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.sharedReqCorporationName = this.jobMatchObject.corporateCompanyName;
            this.sharedReqBUName = this.jobMatchObject.clientOrBUName;
            this.sharedReqVendorName = this.companyName;
            if (this.jobMatchObject.isCorporateLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                this.scheduleData.isCompany = true;
            }
            else if (this.jobMatchObject.isClientOrBuLevelRequisition) {
                this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                this.scheduleData.isCompany = false;
            }
            /*
                in vendor perspective, users can be added only for a vendor when Corp or BU is selected.
                since one of Corp or BU will be selected by default, make the addUser option disabled.
             */
            this.showAddUserOptionFlag = false;
        }
        // determine if add user option is allowed for this user
        if (this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin() || (this.userRoleService.isLoggedInUserCompanyAdmin() && !this.isCorporateFlag)) {
            // admin user, add user is allowed in all cases
            this.canAddUserAtCompanyLevel = true;
            this.canAddUserAtClientOrBULevel = true;
        }
        else if (this.isCorporateFlag) {
            this.canAddUserAtCompanyLevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderCorporateOnMeetingSchedule;
            this.canAddUserAtClientOrBULevel = !this.jobMatchObject.hasNoAccessToCreateUserUnderBUOnMeetingSchedule;
        }
        else {
            // for non admin user
            this.userService.getUserRoleEntityScope(function (data) {
                // if scope is
                if (data.allclientOrBU) {
                    _this.canAddUserAtCompanyLevel = true;
                    _this.canAddUserAtClientOrBULevel = true;
                }
                else if (data.clientOrBUList.length) {
                    _this.canAddUserAtCompanyLevel = false;
                    if (_.findIndex(data.clientOrBUList, { companyId: _this.clientId }) == -1) {
                        _this.canAddUserAtClientOrBULevel = false;
                    }
                    else {
                        _this.canAddUserAtClientOrBULevel = true;
                    }
                }
                else {
                    _this.canAddUserAtCompanyLevel = false;
                    _this.canAddUserAtClientOrBULevel = false;
                }
            }, function (error) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        switch (this.itemType) {
            case 'phoneScreen':
                this.itemDisplayLabel = 'Phone Screen';
                this.usersListLabel = 'Select Phone Screen';
                this.userTypeLabel = 'Phone Screener';
                this.noEditableMeetingsLabel = "No 'Scheduled' Phone Screens are available to modify !";
                break;
            case 'interview':
                this.itemDisplayLabel = 'Interview';
                this.usersListLabel = 'Select Interview';
                this.userTypeLabel = 'Interviewer';
                this.noEditableMeetingsLabel = "No 'Scheduled' Interviews are available to modify !";
                break;
        }
        // to disable chrome autocomplete of the type ahead field.
        this.$timeout(function () {
            if (_this.browserService.isGoogleChrome()) {
                $("[placeholder='" + _this.userSearchPlaceholder + "']").attr("autocomplete", "nope");
            }
        }, 200);
    };
    InviteUserToMeetingController.prototype._getPocOnJob = function (successCallback) {
        var _this = this;
        this.jobService.getPocOnJob(this.jobMatchObject.jobMatchJobId, function (data) {
            _this._massagePocData(data);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error, 'danger');
        });
    };
    InviteUserToMeetingController.prototype._massagePocData = function (pocDetails) {
        if (!_.isNull(pocDetails.id)) {
            this.poc = this._getUserObject();
            this.poc.bu = pocDetails.buId;
            this.poc.emailAddress = pocDetails.email;
            this.poc.firstName = pocDetails.firstName;
            this.poc.lastName = pocDetails.lastName;
            this.poc.phoneNumber = pocDetails.mobilephone;
            this.poc.title = pocDetails.title;
            this.poc.userId = pocDetails.id;
            this.poc.isPoc = true;
            this.scheduleData.users.push(this.poc);
            var tagUser = this._getAutoCompleteUserObject(this.poc);
            this.selectedUserObjectsArray.push(tagUser);
        }
    };
    InviteUserToMeetingController.prototype.onFeedbackTypeChange = function (feedbackType) {
        if (feedbackType == 'SINGLE') {
            angular.forEach(this.scheduleData.users, function (user, key) {
                user.isIndividual = false;
            });
        }
        else {
            angular.forEach(this.scheduleData.users, function (user, key) {
                user.isIndividual = true;
            });
        }
    };
    InviteUserToMeetingController.prototype.invite = function () {
        var _this = this;
        this.$timeout(function () {
            if (_this.scheduleData.users.length) {
                var uIErrorExists_1 = false;
                // validate the forms
                angular.forEach(_this.scheduleData.users, function (val, key) {
                    val.addUserForm.$submitted = true;
                    if (val.addUserForm.$invalid) {
                        uIErrorExists_1 = true;
                    }
                });
                if (!uIErrorExists_1 && !_this.inviteUserForm.$invalid) {
                    _this.savingFlag = true;
                    if (_this.editModeFlag == true) {
                        var inviteUsersData = {};
                        inviteUsersData.meetingScheduleId = _this.scheduleData.meetingScheduleId;
                        inviteUsersData.companyId = _this.scheduleData.company;
                        inviteUsersData.meetingInviteType = _this.scheduleData.company;
                        inviteUsersData.users = tslib_1.__spread(_this.scheduleData.users);
                        inviteUsersData.meetingInviteType = "";
                        if (_this.userSearchFlag) {
                            inviteUsersData.meetingInviteType = "EXISTING_USER_INVITE";
                        }
                        else {
                            inviteUsersData.meetingInviteType = "CREATE_EMPLOYEE_INVITE";
                        }
                        _this.meetingService.inviteParticipant(inviteUsersData, true, function (data) {
                            _this.savingFlag = false;
                            bootbox.alert({
                                closeButton: false,
                                title: "<div class='alert alert-success mb-0'><i class='fa fa-check fa-fw fa-lg'></i><strong>Join Invite Sent</strong></div>",
                                message: "Join meeting invite sent successfully",
                                className: "zIndex1060",
                                buttons: {
                                    ok: {
                                        label: 'Ok',
                                        className: 'btn-info'
                                    }
                                },
                                callback: function () {
                                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                }
                            });
                            if (!_.isUndefined(_this.saveCallback)) {
                                _this.saveCallback();
                            }
                        }, function (error) {
                            _this.savingFlag = false;
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                    else {
                        _this.sharedAjsService.schedulePhoneScreenOrInterview(_this.itemType, _this.scheduleData, function (data) {
                            _this.savingFlag = false;
                            if (!_.isUndefined(_this.saveCallback)) {
                                _this.saveCallback();
                            }
                        }, function (error) {
                            _this.savingFlag = false;
                            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        });
                    }
                }
            }
            else if (!_this.inviteUserForm.$invalid) {
                bootbox.alert({
                    closeButton: false,
                    title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>No Users Selected</strong></div>",
                    message: "Please select at least one user to to invited " + _this.itemDisplayLabel + ".",
                    className: "zIndex1060",
                    buttons: {
                        ok: {
                            label: 'Ok',
                            className: 'btn-info'
                        }
                    },
                    callback: function () {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                });
            }
        }, 200);
    };
    InviteUserToMeetingController.prototype.getScheduledItems = function () {
        var _this = this;
        this.loadingFlag = true;
        var loggedInUserId = null;
        if (this.itemType == 'phoneScreen') {
            this.jobMatchService.getPhoneScreeners(this.jobMatchId, this.companyId, loggedInUserId, false, function (data) {
                _this.loadingFlag = false;
                _this.meetingsList = _this._getMeetingsList(data);
                _this.chosenMeeting = _this.meetingsList.filter(function (meeting) { return meeting.id === _this.scheduleId; })[0];
                _this.meetingChanged();
            }, function (error) {
                _this.loadingFlag = false;
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.jobMatchService.getInterviewers(this.jobMatchId, this.companyId, loggedInUserId, false, function (data) {
                _this.loadingFlag = false;
                _this.meetingsList = _this._getMeetingsList(data);
                _this.chosenMeeting = _this.meetingsList.find(function (meeting) { return meeting.id === _this.scheduleId; });
                _this.meetingChanged();
            }, function (error) {
                _this.loadingFlag = false;
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
    };
    InviteUserToMeetingController.prototype._getMeetingsList = function (response) {
        var _this = this;
        var meetingsList = [];
        angular.forEach(response, function (meetingDetails, key) {
            var meeting = {};
            var timeZone = meetingDetails.timeZone;
            if (_.isNull(timeZone)) {
                timeZone = _this.browserTimeZone;
            }
            var startDateTime = new Date(meetingDetails.meetingStartTime);
            var endDateTime = new Date(meetingDetails.meetingEndTime);
            meeting.id = meetingDetails.meetingScheduleId;
            meeting.status = meetingDetails.status;
            meeting.createdByCompanyId = meetingDetails.company;
            meeting.isCreatedByClient = meeting.createdByCompanyId !== null && meeting.createdByCompanyId !== _this.companyId && !_this.isCorporateFlag;
            switch (meeting.status) {
                case 'SCHEDULED':
                    meeting.statusClass = 'fa fa-calendar meeting-icon-scheduled';
                    meeting.statusLabel = 'Scheduled';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'OVERDUE':
                    meeting.statusClass = 'far fa-clock feedback-meeting-icon-overdue';
                    meeting.statusLabel = 'Overdue';
                    meeting.editableFlag = true;
                    _this.editableMeetingsExistFlag = true;
                    break;
                case 'IN_PROGRESS':
                    meeting.statusClass = 'fa fa-hourglass-half meeting-icon-in-progress';
                    meeting.statusLabel = 'In Progress';
                    meeting.editableFlag = false;
                    break;
                case 'COMPLETED':
                    meeting.statusClass = 'fa fa-check meeting-icon-completed';
                    meeting.statusLabel = 'Completed';
                    meeting.editableFlag = false;
                    break;
                case 'CANCELLED':
                    meeting.statusClass = 'fa fa-ban meeting-icon-cancelled';
                    meeting.statusLabel = 'Canceled';
                    meeting.editableFlag = false;
                    break;
                default:
                    // set defaults
                    meeting.statusClass = 'fa fa-question meeting-icon-in-progress';
                    meeting.statusLabel = 'Status Unknown';
                    meeting.editableFlag = false;
            }
            meeting.scheduledTimeInSelectedTimeZone = _this.moment(startDateTime).tz(timeZone).format("MMM DD, YYYY ( hh:mm a") + ' to ' + _this.moment(endDateTime).tz(timeZone).format("hh:mm a )") + ' in ' + timeZone;
            meeting.scheduledTimeInBrowserTimeZone = null;
            if (timeZone != _this.browserTimeZone) {
                meeting.scheduledTimeInBrowserTimeZone = _this.moment(startDateTime).format("MMM DD, YYYY ( hh:mm a") + ' to ' + _this.moment(endDateTime).format("hh:mm a )") + " in your Computer's time zone (" + _this.browserTimeZone + ")";
            }
            meeting.userList = [];
            meeting.userNamesLabel = '';
            angular.forEach(meetingDetails.participants, function (meetingUser, k) {
                var user = {};
                user.userId = meetingUser.id;
                user.userName = meetingUser.firstName;
                if (!_.isUndefined(meetingUser.lastName) && !_.isNull(meetingUser.lastName)) {
                    user.userName += ' ' + meetingUser.lastName;
                }
                user.isPoc = meetingUser.isPoc;
                meeting.userList.push(user);
                if (_this.jobMatchObject.isSharedRequisition && !_this.isCorporateFlag) {
                    if (user.isPoc) {
                        meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                    }
                }
                else {
                    meeting.userNamesLabel = (meeting.userNamesLabel == '' ? user.userName : meeting.userNamesLabel + ', ' + user.userName);
                }
            });
            meetingsList.push(meeting);
        });
        return meetingsList;
    };
    InviteUserToMeetingController.prototype.meetingChanged = function () {
        var _this = this;
        this.showFormFlag = false;
        this.loadingFlag = true;
        this.showUserDetailsFlag = false;
        this.userSearchFlag = true;
        this.isFirstModifyScheduleTimeCall = true;
        if (this.jobMatchObject.isSharedRequisition && !this.isCorporateFlag) {
            this.isSharedRequisitionAccessedByVendor = true;
        }
        this._setUserAccessToFeedback(this.chosenMeeting.createdByCompanyId);
        this.jobMatchService.getMeetingDetails(this.chosenMeeting.id, function (data) {
            _this.scheduleData.users = [];
            _this.selectedUserObjectsArray = [];
            if (!_this.viewMode) {
                _this.addUserTabIndex = 0;
                if (_this.isSharedRequisitionAccessedByVendor) {
                    _this.showUserDetailsFlag = true;
                    _this.userSearchFlag = false;
                    _this.$timeout(function () {
                        _this.addUserTabIndex = 0;
                    }, 100);
                }
            }
            else {
                _this.isUserVendor = true;
                _this.showUserDetailsFlag = true;
                _this.userSearchFlag = false;
                _this._getPocOnJob(function () {
                    _this.showUserDetailsFlag = true;
                    _this.$timeout(function () {
                        _this.addUserTabIndex = 0;
                    }, 100);
                });
                _this.buList.push({ id: _this.jobMatchObject.jobMatchClientId, name: _this.jobMatchObject.jobMatchClientName });
            }
            _this.scheduleData.feedbackType = data.feedbackType;
            _this.scheduleData.company = _this.companyId;
            _this.scheduleData.isCompany = data.isCompany;
            _this.$timeout(function () {
                _this.isFirstModifyScheduleTimeCall = false;
                _this.showFormFlag = true;
                _this.loadingFlag = false;
            }, 2000);
        }, function (error) {
            _this.loadingFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    InviteUserToMeetingController.prototype._setUserAccessToFeedback = function (scheduleCreatedByCompanyId) {
        this.viewMode = scheduleCreatedByCompanyId !== null && scheduleCreatedByCompanyId !== this.companyId && !this.isCorporateFlag;
    };
    InviteUserToMeetingController.prototype._getAutoCompleteUserObject = function (val) {
        var tagUser = {};
        tagUser.displayString = val.firstName;
        tagUser.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
        tagUser.displayString += ' - ' + val.emailAddress;
        tagUser.id = val.userId;
        tagUser.firstName = val.firstName;
        tagUser.lastName = val.lastName;
        tagUser.email = val.emailAddress;
        tagUser.title = val.title;
        tagUser.mobilephone = val.phoneNumber;
        tagUser.isIndividual = val.isIndividual;
        tagUser.isPoc = val.isPoc;
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            tagUser.buId = val.buId;
            tagUser.buName = val.buName;
        }
        else {
            tagUser.departmentName = val.department;
        }
        return tagUser;
    };
    InviteUserToMeetingController.prototype._getTimeStringInAMPMFormat = function (date) {
        return this.moment(date).format("hh:mm A");
    };
    InviteUserToMeetingController.prototype.toggleViewUserDetails = function () {
        this.showUserDetailsFlag = !this.showUserDetailsFlag;
        if (this.showUserDetailsFlag) {
            this.addUserTabIndex = 0;
        }
    };
    InviteUserToMeetingController.prototype.getUsers = function (searchTerm) {
        var searchObject = {
            'companyOrClientBuId': this.scheduleData.isCompany ? this.scheduleData.company : this.clientId,
            'email': searchTerm,
            'firstName': searchTerm,
            'lastName': searchTerm,
            'requisitionId': this.jobId,
            'loggedInCompanyId': this.companyId
        };
        if (this.isSharedRequisitionAccessedByVendor) {
            if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
                searchObject.companyOrClientBuId = this.jobMatchObject.corporateCompanyId;
            }
            else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
                searchObject.companyOrClientBuId = this.jobMatchObject.clientOrBUId;
            }
            else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
                searchObject.companyOrClientBuId = this.companyId;
            }
        }
        return this.userService.getFilteredUsersPromiseForTypeAhead(searchObject).then(function (data) {
            angular.forEach(data, function (val, key) {
                val.displayString = val.firstName;
                val.displayString += _.isNull(val.lastName) ? '' : (' ' + val.lastName);
                val.displayString += ' - ' + val.email;
            });
            return data;
        });
    };
    InviteUserToMeetingController.prototype._resetScheduleData = function () {
        _.remove(this.scheduleData.users, function (user) {
            return user.isPoc == undefined || user.isPoc == false;
        });
        _.remove(this.selectedUserObjectsArray, function (userTag) {
            return userTag.isPoc == undefined || userTag.isPoc == false;
        });
    };
    InviteUserToMeetingController.prototype.addUser = function () {
        var _this = this;
        this.scheduleData.users.push(this._getUserObject());
        this.$timeout(function () {
            _this.addUserTabIndex = _this.scheduleData.users.length - 1;
        }, 200);
    };
    InviteUserToMeetingController.prototype.removeUser = function ($index) {
        var _this = this;
        this.scheduleData.users.splice($index, 1);
        if (this.scheduleData.users.length > 0) {
            this.$timeout(function () {
                _this.addUserTabIndex = _this.scheduleData.users.length - 1;
            }, 200);
        }
    };
    InviteUserToMeetingController.prototype._getUserObject = function () {
        var user = {};
        user.userId = null;
        user.temporaryUserId = Math.floor((Math.random() * 100) + 1).toString();
        user.firstName = '';
        user.lastName = '';
        user.emailAddress = '';
        user.title = '';
        user.phoneNumber = '';
        user.department = null;
        if (this.isCorporateFlag && !this.scheduleData.isCompany) {
            user.buId = this.jobMatchObject.jobMatchClientId;
        }
        user.department = null;
        user.isIndividual = false;
        return user;
    };
    InviteUserToMeetingController.prototype.userTypeChanged = function () {
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        this.inviteUserForm.$submitted = false;
    };
    InviteUserToMeetingController.prototype._removeCreatedUsers = function () {
        _.remove(this.scheduleData.users, function (user) {
            return user.userId == null;
        });
    };
    InviteUserToMeetingController.prototype.companyClientUserTypeChanged = function (userType) {
        var usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc) || this.isCorporateFlag) {
            this._switchCompanyClient();
        }
        else {
            this._showCompanyClientUsersRemoveWarning(userType);
        }
    };
    InviteUserToMeetingController.prototype._showCompanyClientUsersRemoveWarning = function (userType) {
        var _this = this;
        var message = "The chosen user(s) will be removed. Are you sure you want to continue?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._switchCompanyClient();
                }
                else {
                    _this.scheduleData.isCompany = !_this.scheduleData.isCompany;
                }
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    InviteUserToMeetingController.prototype._switchCompanyClient = function () {
        var _this = this;
        // reset the schedule data.
        this.showTagsInput = false;
        if (!this.isCorporateFlag) {
            this._resetScheduleData();
        }
        if (!this.isCorporateFlag && this.scheduleData.isCompany && !this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
        }
        // if it is staffing company and client is chosen, get poc
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.scheduleData.users = [];
            this.selectedUserObjectsArray = [];
            this._getPocOnJob();
        }
        // if it is staffing company and client is chosen, user cannot be added
        if (!this.isCorporateFlag && !this.scheduleData.isCompany) {
            this.showAddUserOptionFlag = false;
            // toggle to user search, if not already in search mode
            if (!this.userSearchFlag) {
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
        else {
            this.showAddUserOptionFlag = true;
        }
        if (this.scheduleData.isCompany && !this.canAddUserAtCompanyLevel) {
            // if logged in user cannot add users at company level
            this.userSearchFlag = true;
            this.userTypeChanged();
        }
        else if (!this.scheduleData.isCompany && !this.canAddUserAtClientOrBULevel) {
            // if logged in user cannot add users are client/Bu level
            this.userSearchFlag = true;
            this.userTypeChanged();
        }
        if (this.isCorporateFlag) {
            this.buList = [];
            if (!this.scheduleData.isCompany) {
                this.buList.push({ id: this.jobMatchObject.jobMatchClientId, name: this.jobMatchObject.jobMatchClientName });
            }
        }
        this.$timeout(function () {
            _this.showTagsInput = true;
        }, 2000);
    };
    InviteUserToMeetingController.prototype.corpBuVendorUserTypeChanged = function (userType) {
        var usersCount = this.scheduleData.users.length;
        if (usersCount == 0 || (usersCount == 1 && this.scheduleData.users[0].isPoc)) {
            this._switchCorpBu();
        }
        else {
            this._showCorpBuUsersRemoveWarning(userType);
        }
    };
    InviteUserToMeetingController.prototype._showCorpBuUsersRemoveWarning = function (userType) {
        var _this = this;
        var message = "The chosen user(s) will be removed. Are you sure you want to cancel?";
        bootbox.confirm({
            closeButton: false,
            title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
            message: message,
            className: "zIndex1060",
            backdrop: true,
            onEscape: false,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-info'
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                if (result) {
                    _this._switchCorpBu();
                }
                else {
                    if (userType == 'Corporation') {
                        _this.sharedReqUserFromCorpOrBuOrVendor = 'Bu';
                    }
                    else {
                        _this.sharedReqUserFromCorpOrBuOrVendor = 'Corp';
                    }
                }
                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
            }
        });
    };
    InviteUserToMeetingController.prototype._switchCorpBu = function () {
        // reset the schedule data.
        this._resetScheduleData();
        if (this.sharedReqUserFromCorpOrBuOrVendor == 'Corp') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.jobMatchObject.corporateCompanyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        }
        else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Bu') {
            this.scheduleData.isCompany = false;
            this.scheduleData.company = this.jobMatchObject.clientOrBUId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = false;
            this.userSearchFlag = true;
            this.userTypeChanged();
            if (this.isUserVendor) {
                this._showPocDetails();
            }
        }
        else if (this.sharedReqUserFromCorpOrBuOrVendor == 'Vendor') {
            this.scheduleData.isCompany = true;
            this.scheduleData.company = this.companyId;
            /*
                in vendor perspective, users can be added only for a vendor and not when Corp or BU is selected.
             */
            this.showAddUserOptionFlag = true;
            if (!this.canAddUserAtCompanyLevel) {
                // if logged in user cannot add users are company level
                this.userSearchFlag = true;
                this.userTypeChanged();
            }
        }
    };
    InviteUserToMeetingController.prototype._showPocDetails = function () {
        var _this = this;
        this.scheduleData.users.push(this.poc);
        this.showUserDetailsFlag = true;
        this.$timeout(function () {
            _this.addUserTabIndex = 0;
        }, 100);
    };
    InviteUserToMeetingController.prototype.userTypeAheadUserAdded = function (tag) {
        this.addUser();
        this.scheduleData.users[this.scheduleData.users.length - 1].userId = tag.id;
        this.scheduleData.users[this.scheduleData.users.length - 1].firstName = tag.firstName;
        this.scheduleData.users[this.scheduleData.users.length - 1].lastName = tag.lastName;
        this.scheduleData.users[this.scheduleData.users.length - 1].emailAddress = tag.email;
        this.scheduleData.users[this.scheduleData.users.length - 1].title = tag.title;
        if (_.isNull(tag.mobilephone)) {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = '-';
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].phoneNumber = tag.mobilephone;
        }
        if (!_.isNull(tag.role) && tag.role.length > 0) {
            this.scheduleData.users[this.scheduleData.users.length - 1].role = tag.role[this.scheduleData.users.length - 1].description;
        }
        if (this.isCorporateFlag || this.jobMatchObject.isSharedRequisition) {
            this.scheduleData.users[this.scheduleData.users.length - 1].buId = tag.buId;
            this.scheduleData.users[this.scheduleData.users.length - 1].buName = tag.buName;
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].department = tag.departmentName;
            if (!_.isNull(tag.departmentName)) {
                var department = { 'id': tag.departmentId, 'name': tag.departmentName };
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray = [];
                this.scheduleData.users[this.scheduleData.users.length - 1].selectedDepartmentObjectsArray.push(department);
                this.scheduleData.users[this.scheduleData.users.length - 1].department = department;
            }
        }
        if (this.scheduleData.feedbackType == 'SINGLE') {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = false;
        }
        else {
            this.scheduleData.users[this.scheduleData.users.length - 1].isIndividual = true;
        }
        // if(this.scheduleData.users.length <= 1) {
        //     this.onFeedbackTypeChange('SINGLE');
        //     this.disableMultipleFeedback = true;
        // }
    };
    InviteUserToMeetingController.prototype.userTypeAheadUserRemoved = function (tag) {
        var _this = this;
        if (tag.isPoc) {
            this.selectedUserObjectsArray.unshift(tag);
            bootbox.alert({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Warning!</strong></div>",
                message: "Point of Contact cannot be removed.",
                className: "zIndex1060",
                buttons: {
                    ok: {
                        label: 'Ok',
                        className: 'btn-info'
                    }
                },
                callback: function () {
                    _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                }
            });
        }
        else {
            var removedIndex = _.findIndex(this.scheduleData.users, { userId: tag.id });
            this.scheduleData.users.splice(removedIndex, 1);
        }
    };
    InviteUserToMeetingController.prototype.getDepartments = function (searchTerm) {
        var searchObject = {
            'searchText': searchTerm,
            'companyId': this.companyId
        };
        return this.employeeService.getDepartmentsPromiseForTypeAhead(searchObject).then(function (data) {
            return data;
        });
    };
    InviteUserToMeetingController.prototype.departmentTypeAheadDepartmentAdded = function (tag, user) {
        user.department = {};
        user.department.name = tag.name;
        if (!_.isNull(tag.id)) {
            user.department.id = tag.id;
        }
    };
    InviteUserToMeetingController.prototype.departmentTypeAheadDepartmentRemoved = function (tag, user) {
        user.department = null;
    };
    InviteUserToMeetingController.prototype.onInternalNoteChanged = function () {
        this.scheduleData.externalNote = this.scheduleData.note;
    };
    InviteUserToMeetingController.prototype.onExternalNoteChange = function (event) {
        this.scheduleData.externalNote = event.externalNote;
    };
    InviteUserToMeetingController.prototype.onCopyNoteChange = function (event) {
        this.copyNote = event.copyNote;
    };
    InviteUserToMeetingController.prototype.resetMeeting = function () {
        this.meetingChanged();
    };
    return InviteUserToMeetingController;
}());
InviteUserToMeetingController.$inject = ['$rootScope', '$timeout', '$filter', 'moment', 'modalService', 'browserService', 'dateTimeUtilityService', 'jobMatchService', 'jobService', 'userService', 'userRoleService', 'employeeService', 'meetingService', 'alertsAndNotificationsService', 'sharedAjsService'];
import * as TEMPLATE from 'raw-loader!./invite-user-to-meeting.html';
export var InviteUserToMeetingComponent = {
    selector: 'inviteUserToMeeting',
    component: {
        bindings: {
            jobMatchObject: '<',
            saveCallback: '&',
            jobLocation: '@',
            itemType: '@',
            jobMatchId: '@',
            scheduleId: '@',
            mode: '@'
        },
        controller: InviteUserToMeetingController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/conference/conference/audioVideoConference/inviteUserToMeeting/invite-user-to-meeting.html'
    }
};
//# sourceMappingURL=invite-user-to-meeting.component.js.map